export const validateForHtmlTag = (value: string, overrideErrorMessage?: string): string | undefined => {
	const completeHtmlTagRegex = /<([\w:-]*)\b([^<>]*)\s*>(.*?)<\/\1>/;
	const selfClosingTagRegex = /<([\w:-]*)\s?\/>/;

	return new RegExp(`${completeHtmlTagRegex.source}|${selfClosingTagRegex.source}`).test(value)
		? overrideErrorMessage || "No HTML tag is permitted."
		: undefined;
};
